import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { TranslocoModule } from '@jsverse/transloco';
import { CustomAttributeFiltersComponentModule } from './components/custom-attribute-filters/custom-attribute-filters.module';
import { ProfileListAvailabilityFilterModule } from './components/profile-list-availability-filter/profile-list-availability-filter.module';
import { ProfileListGroupFilterModule } from './components/profile-list-group-filter/profile-list-group-filter.module';
import { ProfileListIssuerFilterComponentModule } from './components/profile-list-issuer-filter/profile-list-issuer-filter.module';
import { ProfileListSkillCategoryFilterComponent } from './components/profile-list-skill-category-filter/profile-list-skill-category-filter.component';
import { ProfileListLocationFilterComponent } from './components/profile-list-location-filter/profile-list-location-filter.component';
import { ProfileListSkillFilterModule } from './components/profile-list-skill-filter/profile-list-skill-filter.module';
import { ProfileListFiltersComponent } from './profile-list-filters.component';

const MATERIAL_MODULES = [MatIconModule, MatButtonModule];

@NgModule({
  imports: [
    CommonModule,
    A11yModule,
    ProfileListSkillFilterModule,
    ProfileListGroupFilterModule,
    ProfileListAvailabilityFilterModule,
    ProfileListLocationFilterComponent,
    ProfileListSkillCategoryFilterComponent,
    CustomAttributeFiltersComponentModule,
    ProfileListIssuerFilterComponentModule,
    TranslocoModule,
    ...MATERIAL_MODULES,
  ],
  exports: [ProfileListFiltersComponent],
  declarations: [ProfileListFiltersComponent],
})
export class ProfileListFiltersModule {}
